<template>
  <div id="account">
    <div class="intro-wrapper">
      <div class="content">
        <h2>{{ $t("settings.organization.title") }}</h2>
        <p class="description text-muted">
          {{ $t("settings.organization.message") }}
        </p>
        <a href="https://billing.stripe.com/p/login/6oEdT40YrbLLcmsbII" target="_blank" class="btn btn-primary-outline">
          Subscription &amp; billing</a
        >
      </div>
    </div>
    <div class="form-wrapper">
      <form @submit="onSubmit" :class="{ 'loading-view': loadingOrg }">
        <div class="heading">
          <h3>{{ $t("account.ac-heading") }}</h3>
        </div>
        <div class="content">
          <div class="row">
            <div class="col-lg">
              <custom-input
                :inputType="'text'"
                v-model="form.name"
                :name="'business-name'"
                :label="$t('account.ac-info-business-label')"
                :placeholder="$t('account.ac-info-business-label')"
                :labelBG="'#f2f2f2'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <custom-input
                :inputType="'text'"
                v-model="form.address"
                :name="'business-adress'"
                :label="$t('account.ac-info-adress-label')"
                :placeholder="'e.g. Rådhuspladsen 37'"
                :labelBG="'#f2f2f2'"
              />
            </div>

            <div class="col-lg-2">
              <custom-input
                :inputType="'text'"
                v-model="form.zipCode"
                :name="'postal-code'"
                :label="$t('account.ac-info-postal-label')"
                :placeholder="'e.g. 4000'"
                :labelBG="'#f2f2f2'"
              />
            </div>

            <div class="col-lg-4">
              <custom-input
                :inputType="'text'"
                v-model="form.city"
                :name="'business-city'"
                :label="$t('account.ac-info-city-label')"
                :placeholder="'e.g. Copenhagen'"
                :labelBG="'#f2f2f2'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <custom-input
                :inputType="'text'"
                v-model="form.contact"
                :name="'business-contact'"
                :label="$t('account.ac-info-contact-label')"
                :placeholder="'e.g. Marc Nilsson'"
                :labelBG="'#f2f2f2'"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-lg">
              <custom-input
                :inputType="'text'"
                v-model="form.email"
                :name="'business-email'"
                :label="$t('account.ac-info-email-label')"
                :placeholder="'e.g. email@business.com'"
                :labelBG="'#f2f2f2'"
              />
            </div>
            <div class="col-lg">
              <custom-input
                :inputType="'text'"
                v-model="form.phone"
                :name="'business-phone'"
                :label="$t('account.ac-info-phone-label')"
                :placeholder="'e.g. +45 12345678'"
                :labelBG="'#f2f2f2'"
              />
            </div>
          </div>
          <SaveButton
            :buttonText="$t('save')"
            :disabled="!hasChanges"
            :onSave="() => onSubmit"
            :loading="saving"
            :saved="saveComplete"
            :saveErr="saveIncomplete"
            @saveCompleteHandled="saveComplete = false"
            @saveErrHandled="saveIncomplete = false"
            outline
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SaveButton from "@/components/SaveButton";
import CustomInput from "@/components/CustomInput";
export default {
  data() {
    return {
      form: {},
      hasChanges: false,
      saveComplete: false,
      saveIncomplete: false,
      saving: false,
      loadingOrg: false,
      ready: false
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.saving = true;
      this.$store
        .dispatch("changeOrganizationInfo", this.form)
        .then((result) => {
          this.saving = false;
          this.saveComplete = true;
          this.hasChanges = false;
        })
        .catch((e) => {
          this.saving = false;
          this.saveIncomplete = true;
        });
    }
  },
  mounted() {
    this.loadingOrg = true;
    this.$store
      .dispatch("getOrganization")
      .then((res) => {
        this.form = { ...res };
        this.$nextTick(() => (this.ready = true));
      })
      .finally(() => {
        this.loadingOrg = false;
      });
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (this.ready) {
          this.hasChanges = true;
        }
      }
    }
  },
  components: {
    CustomInput,
    SaveButton
  }
};
</script>

<style lang="less">
#account {
  // padding: 0 20px;
  padding-top: 103px;
  form {
    background-color: var(--background-white);
    border-radius: var(--standard-border-radius);
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    .heading {
      border-bottom: 1px solid var(--charcoal-20);
      padding: 12px 20px;
    }
    .content {
      padding: 12px 20px 18px;
    }
    button {
      margin-top: 18px;
    }
  }
}

@media screen and (min-width: 920px) {
  #account {
    display: grid;
    grid-template-columns: 3fr 7fr;
    gap: 42px;
    justify-content: space-between;

    .form-wrapper {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;
      form {
        flex-grow: 1;
        max-width: 800px;
      }
    }
  }
}
</style>
